// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-bold {
  font-weight: bold !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/rewards-components/rewards-request-confirm/rewards-request-confirm.component.scss"],"names":[],"mappings":"AACA;EACI,4BAAA;AAAJ","sourcesContent":["\n.text-bold {\n    font-weight: bold !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
